(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["power-offer-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  let pending = false;
  const reset = () => {
    pending = false;
    document.querySelectorAll('[data-power-offer] [data-was-disabled]').forEach(button => {
      button.disabled = button.dataset.wasDisabled === 'true';
      button.removeAttribute('data-was-disabled');
      button.removeAttribute('aria-busy');
    });
  };
  window.addEventListener('pageshow', reset);
  document.addEventListener('change', event => {
    const form = event.target.closest('form[data-power-offer]');
    if (!form) return;
    const summary = form.querySelector('[data-color-summary]');
    summary.textContent = Array.from(form.querySelectorAll('select')).map(select => select.selectedOptions[0]?.textContent || '').join(' + ');
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    const quantity = url.hash === '#power-offer-free' ? 2 : url.hash === '#power-offer-duo' ? 1 : 0;
    if (!quantity) return;
    const scope = link.closest('.pc-bundle') || document;
    const form = scope.querySelector(`form[data-power-offer][data-offer-quantity="${quantity}"]`);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('button[type="submit"]');
    if (!button.disabled && !pending) form.requestSubmit(button);
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-power-offer]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    const errorBox = form.querySelector('.pc-offer-error');
    const notice = document.querySelector('[data-power-offer-notice]');
    errorBox.hidden = true;
    if (notice) notice.hidden = true;
    const formData = new FormData(form);
    document.querySelectorAll('[data-power-offer] button[type="submit"]').forEach(button => {
      button.dataset.wasDisabled = String(button.disabled);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });
    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: formData
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.errorMessage);
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      const message = error instanceof TypeError ? form.dataset.errorMessage : error.message || form.dataset.errorMessage;
      errorBox.textContent = message;
      errorBox.hidden = false;
      if (notice) {
        notice.textContent = message;
        notice.hidden = false;
      }
      reset();
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
